import { FileText, Shield, CheckSquare, BookOpen } from "lucide-react";
import type { EntityContext } from "@/stores/chat-context-store";

export const ENTITY_ICONS: Record<EntityContext["type"], typeof FileText> = {
  document: FileText,
  audit: Shield,
  "checklist-item": CheckSquare,
  clause: BookOpen,
};
